export default "__VITE_ASSET__ef9c94a4__"